import ExecutiveBriefingModule from './ExecutiveBriefingModule';

export default function ExecutiveBriefingMerchandise({ user }) {
  return (
    <ExecutiveBriefingModule 
      user={user} 
      moduleName="Merchandise"
      moduleTitle="Merchandise"
    />
  );
}
